/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { transformChineseBase } from '../utils/index'
import {
  // eslint-disable-next-line prettier/prettier
  type Volume,
  type Chapter,
  type Bookmark,
  type SubsVolume,
  type SubsChapter,
  type RiskParams,
  type RiskData,
  ServiceError,
  ErrorType,
} from '@yuewen/reader'
import { axiosInstance } from '@share/request/axios'
import { login } from '../utils/login'
import FansLimitDialog from './components/ChapterReviewFansLimit/index.vue'
import PaymentErrorDialog from './components/PaymentError/index.vue'
import funcHoc from './components/useAnyDialog'
import { getCookie } from '@share/utils/index'
import {
  ReqSubChapters,
  Code15003,
  SubscribeReqParam,
  QuickPayResultData,
} from './type'
import {
  ISdkRes,
  IQDRiskParams,
  MyResponseType,
  IQDExceptionHandlingData,
} from '@share/types'
import { XOR } from '@root/types'
/**
 * 获取章节列表信息
 */
export type VsType = {
  vN: string
  vS: string
  cs: CsType[]
  vId: number
  wCnt: number
}
export type CsType = {
  cN: string
  uT: string
  sT: number
  sS: number
  id: number
  cU: string
  p?: number
  cnt: number
  s: number
}
const $t = transformChineseBase()
const dealVsInfo = <T, R>(vs: VsType[], isSub?: boolean): R[] => {
  const volumeList: R[] = []
  vs.forEach((item: VsType) => {
    const chapterList: T[] = []
    if (item.cs && item.cs.length) {
      item.cs.forEach((item2) => {
        let status = -1
        if (item.vS) {
          if (item2.sS === 0) {
            status = 1
          } else {
            status = 2
          }
        }
        if (isSub) {
          status = item2.s ? 2 : 1
          status = item2.p === 0 ? -1 : status
        }
        const priceParam = isSub
          ? {
              price: item2.p,
            }
          : {}
        chapterList.push({
          id: `${item2.id}`,
          title: item2.cN,
          status,
          publishTime: item2.uT,
          ext: {
            cU: item2.cU,
            wordCount: item2.cnt,
          },
          wordCount: item2.cnt,
          ...priceParam,
        } as T)
      })
    }
    volumeList.push({
      id: `${item.vId}`,
      title: item.vN,
      vip: Boolean(item.vS),
      list: chapterList,
    } as R)
  })
  return volumeList
}
export const fetchChapterListAjax = async (
  bookId: string,
): Promise<Volume[]> => {
  if (import.meta.env.SSR) {
    return []
  }
  let res = null
  let volumeList: Volume[] = []
  res = await axiosInstance.request<MyResponseType<{ vs: VsType[] }>>({
    method: 'GET',
    url: '/ajax/book/category',
    params: {
      bookId,
    },
  })
  if (res?.data?.data?.vs) {
    const { vs } = res.data.data
    volumeList = dealVsInfo<Chapter, Volume>(vs)
  }
  return volumeList
}

/**
 * 加入书架
 * @param bookId
 * @returns
 */
export const addToBookShelf = async (bookId: string): Promise<void> => {
  let res = null
  try {
    res = await axiosInstance.request<MyResponseType<unknown>>({
      method: 'GET',
      url: '/webcommon/bookshelf/addbooks',
      params: {
        bookId,
      },
    })
    if (res.data.code === 1002) {
      throw new ServiceError({
        msg: $t('已经在书架中'),
        type: ErrorType.Other,
      })
    }
    if (res.data.code === 1003) {
      throw new ServiceError({
        msg: $t('书架已满'),
        type: ErrorType.Other,
      })
    }
    if (res.data.code === 1004) {
      throw new ServiceError({
        msg: $t('加入失败'),
        type: ErrorType.Other,
      })
    }
    if (res.data.code !== 0) {
      throw new ServiceError({
        msg: res.data.msg || '',
        type: ErrorType.Other,
      })
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error)
    throw new ServiceError({
      msg: $t('加入书架失败'),
      type: ErrorType.Other,
    })
  }
}

/**
 * 获取书签列表
 * @param bookId
 * @returns
 */
type markerListType = {
  bookMarkId: string
  chapterId: string
  chapterName: string
  addTimes: number
  chapterUrl: string
}
export const getBookMarkList = async (bookId: string): Promise<Bookmark[]> => {
  const res = await axiosInstance.request<
    MyResponseType<{ markerList: markerListType[] }>
  >({
    method: 'GET',
    url: '/ajax/chapter/getBookMarkList',
    params: {
      bookId,
    },
  })
  if (res?.data?.code === 0 && res.data?.data?.markerList?.length) {
    const markerListTrans: Bookmark[] = []
    const { markerList } = res.data.data as { markerList: markerListType[] }
    markerList.forEach((item: markerListType) => {
      markerListTrans.push({
        id: item.bookMarkId,
        chapterId: item.chapterId,
        title: item.chapterName,
        time: (item?.addTimes || 0) * 1000,
        ext: {
          chapterUrl: item.chapterUrl,
        },
      })
    })
    return markerListTrans
  }
  return []
}

/**
 * 获取批量订阅列表
 * @param bookId
 * @returns
 */
export const getBatchSubsList = async (
  bookId: string,
): Promise<SubsVolume[]> => {
  let volumeList: SubsVolume[] = []
  const res = await axiosInstance.request<MyResponseType<{ vs: VsType[] }>>({
    method: 'GET',
    url: '/webcommon/subscription/pcGetVipChapters',
    params: {
      bookId,
    },
  })
  if (res?.data?.data.vs) {
    const { vs } = res.data.data
    volumeList = dealVsInfo<SubsChapter, SubsVolume>(vs, true)
  }
  return volumeList
}

/**
 * 处理风控参数
 */

export const getRiskDataReqParam = (
  riskInfo: RiskData,
  sdkRes: ISdkRes,
): IQDRiskParams => {
  const baseParams = {
    banId: riskInfo.banId,
    sessionKey: riskInfo.sessionKey,
  }
  let params: IQDRiskParams = baseParams
  if (Number(riskInfo.banId) === 2) {
    if (Number(riskInfo.captchaType) === 1) {
      params = {
        ...baseParams,
        challenge: sdkRes?.challenge,
        seccode: sdkRes?.seccode,
        validate: sdkRes?.validate,
      }
    }
    if (Number(riskInfo.captchaType) === 0) {
      params = {
        ...baseParams,
        captchaTicket: sdkRes?.ticket,
        captchaRandStr: sdkRes?.randstr,
      }
    }
  }
  return params
}

/**
 * 处理风控
 * @param riskInfo
 * @param sdkRes
 * @param bookId
 * @param chapterId
 * @returns
 */
export const handleRisk = async (
  riskInfo: RiskData,
  sdkRes: ISdkRes,
  bookId: string,
  chapterId: string,
): Promise<boolean> => {
  const csrfToken = getCookie('_csrfToken') || ''
  const params = getRiskDataReqParam(riskInfo, sdkRes)
  const res = await axiosInstance.request<MyResponseType<unknown>>({
    method: 'POST',
    url: `/ajax/chapter/riskverify?_csrfToken=${csrfToken}`,
    data: JSON.stringify({ ...params, bookId, chapterId }),
    headers: {
      'Content-type': 'application/json',
    },
  })
  if (res?.data?.code === 0) {
    return true
  }
  return false
}

/**
 * 订阅
 */
const getFanLimitReason = (code15003: Code15003): string => {
  const { conList = [] } = code15003
  const fansConInfo = conList.find((item) => item.conditionType === 3)
  if (fansConInfo) {
    return `${fansConInfo.title.replace('%s', `${fansConInfo.target}`)},${
      fansConInfo.subTitle
    }`
  }
  return ''
}
export type BaseCommonParamSubscribe = {
  salesMode: number
  bookId: number
  isRenew: number
}
export type CommonParamSubscribe = BaseCommonParamSubscribe & {
  riskParams?: RiskParams
}

/**
 * 获取订阅参数
 * @param commonParamSubscribe
 * @param chapters
 * @returns
 */
export const getSubscribeParam = (
  commonParamSubscribe: CommonParamSubscribe,
  chapters: SubsChapter[],
): SubscribeReqParam & IQDRiskParams => {
  const { salesMode, bookId, isRenew, riskParams } = commonParamSubscribe
  let riskRequestParam = {}
  if (riskParams && riskParams.serverRes) {
    riskRequestParam = getRiskDataReqParam(
      riskParams.serverRes,
      riskParams.sdkRes,
    )
  }
  let chapterPrice = 0
  const reqChapters: ReqSubChapters[] = []
  chapters.forEach((item) => {
    const { uuid, wordCount } = item.ext as { uuid: string; wordCount: number }
    chapterPrice += item.price
    reqChapters.push({
      chapterId: Number(item.id),
      price: item.price,
      uuid,
      chapterCnt: wordCount,
    })
  })
  const requireParam: SubscribeReqParam & IQDRiskParams = {
    bookId,
    chapterPrice,
    chapters: reqChapters,
    isRenew,
    isBuyAll: salesMode === 1 ? 0 : 1,
    ...riskRequestParam,
  }
  return requireParam
}

/**
 *
 * @param res 处理订阅结果和错误处理
 */
export const subscribeAndQuickPayDealResult = (
  data: MyResponseType<XOR<QuickPayResultData, IQDExceptionHandlingData>>,
  trackParam: {
    bid: number
  },
  isQuickPay?: boolean,
): MyResponseType<XOR<QuickPayResultData, IQDExceptionHandlingData>> => {
  const { code, msg } = data
  const { riskInfo, code15003 } = data?.data || {}
  switch (code) {
    // 订阅成功
    case 0:
      break
    // 价格变动
    case 2000:
      throw new ServiceError({
        type: ErrorType.PriceChange,
        msg: $t('订阅失败'),
        desc: $t('价格发生变动，请重新确认支付金额'),
      })
    // 订阅失败
    case 2003:
      throw new ServiceError({
        type: ErrorType.PriceChange,
        msg: $t('订阅失败'),
        desc: $t('其他消费导致账户余额不足'),
      })
    // 余额不足,余额发生变化导致不足
    case 2006:
      throw new ServiceError({
        type: ErrorType.PriceChange,
        msg: $t('订阅失败'),
        desc: $t('余额发生变动，请重新确认支付金额'),
      })
    // 未登录
    case 1000:
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      login()
      throw new ServiceError({
        type: ErrorType.Other,
        mute: true,
        msg: '',
      })
    // 中风控
    case 15002:
      throw new ServiceError({
        type: ErrorType.Risk,
        msg: '',
        risk: riskInfo,
      })
    case 15001:
      throw new ServiceError({
        type: ErrorType.Other,
        msg: $t(msg || '当前网络环境风险较高，为保护您的账号安全，请稍后再试'),
      })
    case 15003:
      funcHoc(FansLimitDialog, {
        show: true,
        title: code15003?.title,
        fanLimitReason: code15003 ? $t(getFanLimitReason(code15003)) : '',
        from: 'sub',
        trackParam,
      })
      throw new ServiceError({
        type: ErrorType.Other,
        mute: true,
        msg: '',
      })
    case 1070: // 中了消费风控
    case 1074:
    case 1076:
      funcHoc(PaymentErrorDialog, {
        show: true,
        code,
        info1070:
          code === 1070
            ? {
                mobileNum: data?.data?.mobile,
                logId: data?.data?.logId,
              }
            : {},
      })
      throw new ServiceError({
        type: ErrorType.Other,
        mute: true,
        msg: '',
      })
    // 消费异常
    default:
      throw new ServiceError({
        type: ErrorType.Other,
        msg: $t(`${isQuickPay ? '充值' : '订阅'}失败`),
        desc: $t(msg || ''),
      })
  }
  return data
}

export const rewardQuickPayDealResult = (
  data: MyResponseType<XOR<QuickPayResultData, IQDExceptionHandlingData>>,
): MyResponseType<XOR<QuickPayResultData, IQDExceptionHandlingData>> => {
  const { code, msg } = data
  switch (code) {
    case 0:
    case 2009:
      break
    // 充值成功但打赏失败 1052
    case 1052:
      throw new ServiceError({
        type: ErrorType.Other,
        mute: true,
        msg: '充值中，请稍后',
      })
    // 充值中，loading 1053
    case 1053:
      throw new ServiceError({
        type: ErrorType.Other,
        mute: true,
        msg: '充值金额已到账，打赏出现异常',
      })
    // 余额不足 1054
    case 1054:
      throw new ServiceError({
        type: ErrorType.Other,
        mute: true,
        msg: '余额不足',
      })
    case 2002:
      throw new ServiceError({
        type: ErrorType.Other,
        mute: true,
        msg: '充值失败',
      })
    case 2004:
      throw new ServiceError({
        type: ErrorType.Other,
        mute: true,
        msg: '充值未到账',
      })
    // 价格变动
    case 2000:
      throw new ServiceError({
        type: ErrorType.PriceChange,
        msg: $t('打赏失败'),
        desc: $t('价格发生变动，请重新确认支付金额'),
      })
    // 订阅失败
    case 2003:
      throw new ServiceError({
        type: ErrorType.Balance,
        msg: $t('打赏失败'),
        desc: $t('其他消费导致账户余额不足'),
      })
    // 余额不足,余额发生变化导致不足
    case 2006:
      throw new ServiceError({
        type: ErrorType.Balance,
        msg: $t('打赏失败'),
        desc: $t('余额发生变动，请重新确认支付金额'),
      })
    // 未登录
    case 1000:
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      login()
      throw new ServiceError({
        type: ErrorType.Other,
        mute: true,
        msg: '',
      })
    case 1070: // 中了消费风控
    case 1074:
    case 1076:
      funcHoc(PaymentErrorDialog, {
        show: true,
        code,
        info1070:
          code === 1070
            ? {
                mobileNum: data?.data?.mobileNum,
                logId: data?.data?.logId,
              }
            : {},
      })
      throw new ServiceError({
        type: ErrorType.Other,
        mute: true,
        msg: '',
      })
    // 消费异常
    default:
      throw new ServiceError({
        type: ErrorType.Other,
        msg: $t('打赏失败'),
        desc: $t(msg || ''),
      })
  }
  return data
}

/**
 * 订阅 ajax请求
 * @param chapters
 * @param salesMode
 * @param bookId
 * @param isRenew
 * @param riskParams
 */
export const subscribeChapterAjax = async (
  chapters: SubsChapter[],
  salesMode: number,
  bookId: number,
  isRenew: boolean,
  riskParams?: RiskParams,
  subClickType?: string,
// eslint-disable-next-line max-params
): Promise<void> => {
  const requireParam = getSubscribeParam(
    {
      salesMode,
      bookId,
      isRenew: Number(isRenew),
      riskParams,
    },
    chapters,
  )
  const chapterIds =
    (requireParam.chapters &&
      requireParam.chapters
        .map((item) => {
          return item.chapterId
        })
        .join(',')) ||
    ''
  const str = `${getCookie('ywguid')},${getCookie('_csrfToken')},${bookId}${
    chapterIds && chapterIds.length ? `,${chapterIds}` : ''
  }`
  const stoken = window.Fock.sign(str)
  window.AegisV2?.report({
    msg: 'ywqd-sub:report',
    session: window.AegisV2?.snapshootInfo?.session,
    ext1: subClickType,
    trace: 'trace',
  })
  try{
      const res = await axiosInstance.request<
      MyResponseType<XOR<QuickPayResultData, IQDExceptionHandlingData>>
    >({
      method: 'POST',
      url: '/webcommon/subscription/pcSubscribe',
      data: { ...requireParam, stoken },
    })
   const { code, msg } = res?.data
     window.AegisV2?.report({
      msg: 'ywqd-sub:report',
      session: window.AegisV2.snapshootInfo?.session,
      ext1: subClickType,
      trace: 'trace',
      ex2: code,
      ex3: msg,
   })
    subscribeAndQuickPayDealResult(res.data, {
      bid: bookId,
    })
  }catch(error){
    window.AegisV2?.report({
      msg: 'ywqd-sub:report',
      session: window.AegisV2.snapshootInfo?.session,
      ext1: subClickType,
      trace: 'trace',
      ex2: '3',
      ex3: error,
    })
  }
  
}

/**
 * 保存用户设置
 * @param bookId
 * @params autoBuy settings
 * @returns
 */
export const saveUserSetting = async (
  bookId: string,
  params: {
    [key: string]: string | number
  },
): Promise<boolean> => {
  const res = await axiosInstance.request<MyResponseType<unknown>>({
    method: 'POST',
    url: `/ajax/chapter/saveUserSetting`,
    data: {
      bookId,
      ...params,
    },
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })
  if (res?.data?.code === 0) {
    return true
  }
  throw new ServiceError({
    type: ErrorType.Other,
    msg: $t('设置失败'),
  })
}

/**
 * 查询自动订阅状态
 * @param bookId
 * @returns
 */
export const getSubscribeSet = async (bookId: string): Promise<boolean> => {
  const res = await axiosInstance.request<MyResponseType<{ autoBuy: number }>>({
    method: 'GET',
    url: '/ajax/chapter/getSubscribeSet',
    params: {
      bookId,
    },
  })
  if (res?.data?.code === 0) {
    const { autoBuy } = res?.data?.data
    return Boolean(autoBuy)
  }
  return false
}

/**
 * 获取短链
 * @param rawUrl
 * @returns
 */
export const getShortUrl = async (rawUrl: string): Promise<string> => {
  const res = await axiosInstance.request<MyResponseType<string>>({
    method: 'GET',
    url: `/webcommon/tool/shortUrl`,
    params: {
      rawUrl,
    },
    withCredentials: true,
  })
  if (res?.data?.code === 0 && res?.data?.data) {
    return res?.data?.data
  }
  return ''
}

export const getUserBalance = async (): Promise<number> => {
  const res = await axiosInstance.request<MyResponseType<{ balance: number }>>({
    method: 'GET',
    url: '/webcommon/user/getSubscribeBalance',
  })
  if (res?.data?.code === 0) {
    return res?.data?.data?.balance
  }
  throw new ServiceError({
    type: ErrorType.Other,
    msg: res.data.msg ? $t(res.data.msg) : $t('获取余额失败'),
  })
}
